import {
  FETCH_TEACHER_APPROVED_COURSES_REQUEST,
  FETCH_TEACHER_APPROVED_COURSES_SUCCESS,
  FETCH_TEACHER_APPROVED_COURSES_FAILURE,
} from "../Actions/types"; // Import the types

const initialState = {
  loading: false,
  approvedCourses: [],
  error: null,
};

const TeacherApprovedCoursesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TEACHER_APPROVED_COURSES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_TEACHER_APPROVED_COURSES_SUCCESS:
      return {
        ...state,
        loading: false,
        approvedCourses: action.payload,
        error: null,
      };
    case FETCH_TEACHER_APPROVED_COURSES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default TeacherApprovedCoursesReducer;
